export const getImportErrorsTranslations = t => {
  const translations = t => ({
    invalidPasswordOrDataCorrupted: t("errors.importNode.invalidPasswordOrDataCorrupted"),
    mismatchedVersion: t("errors.importNode.mismatchedVersion")
  });

  return translations(t !== undefined ? t : str => str);
};
